import React from "react";
import Accordion from "react-bootstrap/Accordion";

const FAQs = () => {
  const faqsData = [
    {
      question: "Who is Justin?",
      answer:
        "At home I'm a dad, an author, and a reliable cook of about five recipes. I like good television, camping, and traveling anywhere I haven't been yet. At work I've spent twenty-three years building software, the last nine of them deep in Epicor ERP integrations. What has kept me in it is that the interesting problems are always the ones where the answer isn't obvious yet &mdash; I would rather go find out than guess.",
    },
    {
      question: "How do you approach a new integration?",
      answer:
        "Questions first. Most integration failures are specification failures &mdash; two systems agree on a field name and quietly disagree about what it means. I spend the time up front tracing what the data actually does on both sides, often down to the API methods underneath the documentation, because that is where the surprises live. Then I build something that fails safely: retries that cannot duplicate a record, and errors that tell you which side of the commit boundary you landed on.",
    },
    {
      question: "What does working with you look like?",
      answer:
        "I document the method alongside the result. If I hand you a number, it arrives with how it was derived, what was excluded, and where it could be wrong in either direction &mdash; a finding you can defend under scrutiny is worth more than a confident one you cannot. And I write code other developers can read and repurpose, because most of what I build outlives my involvement with it.",
    },
    {
      question: "What kind of work are you looking for?",
      answer:
        "I'm drawn to companies that treat planning, testing and communication as part of building the product rather than overhead. I have worked both ways, and the difference shows up in the software &mdash; it lasts longer and costs less to change. When a team genuinely values that, the work is a pleasure. Subject matter: ERP integration, full-stack web, and anything with a real data problem underneath it.",
    },
  ];

  return (
    <section id="faq" className="section bg-light">
      <div className="container">
        <div className="row gy-5">
          <div className="col-lg-6 order-1 order-lg-0 wow fadeInUp">
            {/* Heading */}
            <p className="text-center text-lg-start mb-2">
              <span className="bg-primary text-dark px-2">FAQ</span>
            </p>
            <h2 className="text-10 fw-600 text-center text-lg-start mb-5">
              Have any questions?
            </h2>
            {/* Heading end*/}

            <Accordion flush defaultActiveKey="0">
              {faqsData.length > 0 &&
                faqsData.map((faq, index) => (
                  <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header>{faq.question}</Accordion.Header>
                    <Accordion.Body
                      dangerouslySetInnerHTML={{ __html: faq.answer }}
                    ></Accordion.Body>
                  </Accordion.Item>
                ))}
            </Accordion>
          </div>
          <div
            className="col-lg-6 d-flex align-items-center justify-content-center order-0 order-lg-1 wow fadeIn"
            data-wow-delay="1s"
          >
            {" "}
            <img
              className="img-fluid"
              src="images/faq.png"
              title="FAQ"
              alt="faq"
            />{" "}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQs;
